<dx-popup #dlgCreditCalc [width]="600" [height]="400" [showTitle]="true" title="Insufficient Credits" [resizeEnabled]=true
    [dragEnabled]="true" [showCloseButton]="true" [hideOnOutsideClick]="false">

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="OkButtonOptions">
    </dxi-toolbar-item>
    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="CancelButtonOptions">
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <dx-form [formData]="creditCalcInfo" [colCount]=2 showColonAfterLabel="false">
            <dxi-item itemType="simple" >
                Client Name
            </dxi-item>
            <dxi-item itemType="simple" >
                {{this.creditCalcInfo.ClientName}}
            </dxi-item>

            <dxi-item itemType="simple" >
                Client Credits
            </dxi-item>
            <dxi-item itemType="simple" >
                {{this.creditCalcInfo.ClientCredits}}
            </dxi-item>

            <dxi-item itemType="simple" >
                Session Name
            </dxi-item>
            <dxi-item itemType="simple" >
                {{this.creditCalcInfo.SessionName}}
            </dxi-item>

            <dxi-item itemType="simple" >
                Session Cost
            </dxi-item>
            <dxi-item itemType="simple" >
                {{this.creditCalcInfo.SessionCost}}
            </dxi-item>

            <dxi-item itemType="simple" >
                Session Cost (Credits)
            </dxi-item>
            <dxi-item itemType="simple" >
                {{this.creditCalcInfo.SessionCredits}}
            </dxi-item>

            <dxi-item itemType="simple" >
                Credits Required
            </dxi-item>
            <dxi-item itemType="simple" >
                {{this.creditCalcInfo.CreditsRequired}}
            </dxi-item>
                       
            <dxi-item itemType="simple" >
                Amount Outstanding
            </dxi-item>
            <dxi-item dataField="ExtraCost" editorType="dxNumberBox"
                [editorOptions]="{ format:'£#,##0.00', min:'0.0', max:'99999.99', showSpinButtons:true, showClearButton:true, onValueChanged: this.onPriceChanged.bind(this) }">
                <dxo-label text=" " showColon="false" [visible]="false"></dxo-label>
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>